import type { SuperAdminPausedRequest } from "@nlc/shared-types";

import { whitelabelRowClassName } from "@/features/requests/constants/accountTags";

import type { TableConfig } from "../../../types/tables";

import { inlineBrandCell } from "../../helpers/cellRenderers";
import {
  accountCellWithSlotTooltip,
  createdByCell,
  dateCell,
  nameCell,
  requestDesignTypeCell,
} from "../../helpers/commonCells";

// Paused Tab Configuration for SuperAdmin
// Columns: Name, Account, Brand, Created by, Created date, Request/Design type
export const pausedTableConfig: TableConfig<SuperAdminPausedRequest> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: 220,
    },
    {
      accessor: "account",
      cellRenderer: accountCellWithSlotTooltip,
      header: "Account",
      key: "account",
      sortable: true,
      width: 180,
    },
    {
      accessor: "brand",
      cellRenderer: inlineBrandCell, // Inline editable
      header: "Brand",
      key: "brand",
      sortable: true,
      width: 160,
    },
    {
      accessor: "createdBy",
      cellRenderer: createdByCell,
      header: "Created by",
      key: "createdBy",
      sortable: true,
      width: 140,
    },
    {
      accessor: "createdAt",
      cellRenderer: dateCell,
      header: "Created date",
      key: "createdAt",
      sortable: true,
      width: 130,
    },
    {
      accessor: "designType",
      cellRenderer: requestDesignTypeCell,
      header: "Request/Design type",
      key: "designType",
      sortable: true,
      width: 180,
    },
  ],
  defaultSort: {
    column: "createdAt",
    direction: "desc",
  },
  enableSorting: true,
  getRowClassName: whitelabelRowClassName,
  id: "superadmin-paused-requests",
  title: "Paused",
};
